import { Link } from "react-router-dom"

const STEPS = [
  { n: '01', title: 'Choose Your Astrologer', desc: 'Browse our verified Vedic experts and pick the right specialist for your concern.' },
  { n: '02', title: 'Pick a Time Slot', desc: 'Select a date and time that suits you, and share your birth details for your chart.' },
  { n: '03', title: 'Confirm & Pay', desc: 'Lock your appointment with a quick, secure payment. Instant confirmation provided.' },
  { n: '04', title: 'Consult & Remedies', desc: 'Connect over a private video or call, get answers and receive personalised remedies.' },
]

export default function HowItWorksSection() {
  return (
    <section className="relative overflow-hidden py-16 md:py-24 md:px-18 bg-white text-primary">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-secondary/10 rounded-full blur-[120px] animate-pulse" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/5 rounded-full blur-[120px] animate-pulse" style={{ animationDelay: '1s' }} />
      </div>
      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="mx-auto mb-20 flex max-w-2xl flex-col items-center text-center">
          <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold mb-4">Simple Process</span>
          <h2 className="font-cinzel text-4xl md:text-5xl uppercase tracking-tight text-primary mb-6">
            How It <span className="text-secondary">Works</span>
          </h2>
          <p className="text-primary/55 text-sm md:text-base leading-relaxed">
            Booking a consultation with an astrologer takes just four simple steps — from choosing your expert to receiving your remedies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((step) => (
            <div
              key={step.n}
              className="group relative p-8 rounded-3xl border border-secondary/20 bg-white/80 backdrop-blur-sm shadow-[0_10px_30px_rgba(200,146,42,0.06)] hover:border-secondary/50 transition-all duration-500 hover:-translate-y-2"
            >
              <div className="font-cinzel text-secondary/10 text-6xl font-bold mb-6 group-hover:text-secondary/25 transition-colors duration-500">{step.n}</div>
              <h3 className="text-lg font-cinzel text-primary mb-3 group-hover:text-secondary transition-colors">{step.title}</h3>
              <p className="text-primary/55 text-xs leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <Link
            to="/consultations"
            className="inline-flex items-center gap-2 px-10 py-4 bg-primary hover:bg-secondary text-white text-xs font-bold uppercase tracking-widest rounded-full transition-all hover:shadow-2xl"
          >
            Book Your Consultation
          </Link>
        </div>
      </div>
    </section>
  )
}
